import React from 'react'
import ColorItem from './ColorItem'

export default function ColorList() {
    return (
        <ColorItem />
    )
}
